import { WarehouseMode, WarehousePresentation } from './host-bridge.messages';
import { chainRid, chainTab, RecordChain } from './record-chain';

export interface IframeUrlState {
	chain: RecordChain;
	mode: WarehouseMode | null;
	tab: number | null;
	page: string | null;
}

export type IframeEmbedParams = Partial<{
	pagename: string;
	rid: string;
	open: readonly string[];
	mode: WarehouseMode;
	tab: number;
	opentab: readonly (number | null)[];
}>;

export function urlStateToEmbedParams(state: IframeUrlState, presentation: WarehousePresentation): IframeEmbedParams {
	const hasRecord = state.chain.length > 0;
	const recordAsModal = presentation === 'modal' && hasRecord;
	const page = state.page !== null ? { pagename: state.page } : {};

	if (recordAsModal) {
		const tabs = state.chain.map((entry) => entry.tab);
		const anyTab = tabs.some((t) => t !== null);
		return {
			...page,
			open: state.chain.map((entry) => entry.rid),
			...(state.mode !== null ? { mode: state.mode } : {}),
			...(state.tab !== null ? { tab: state.tab } : {}),
			...(anyTab ? { opentab: tabs } : {}),
		};
	}

	const rid = chainRid(state.chain);
	const tab = chainTab(state.chain) ?? state.tab;
	return {
		...page,
		...(rid !== null ? { rid } : {}),
		...(state.mode !== null ? { mode: state.mode } : {}),
		...(tab !== null ? { tab } : {}),
	};
}

export function appendEmbedParams(baseEmbedUrl: string, params: IframeEmbedParams): string {
	const pairs: string[] = [];
	const push = (name: string, value: string | number) => pairs.push(`${name}=${encodeURIComponent(String(value))}`);

	if (params.rid !== undefined) push('rid', params.rid);
	(params.open ?? []).forEach((rid) => push('open', rid));
	if (params.mode !== undefined) push('mode', params.mode);
	if (params.tab !== undefined) push('tab', params.tab);
	(params.opentab ?? []).forEach((tab) => push('opentab', tab === null ? '' : tab));

	if (pairs.length === 0) return baseEmbedUrl;
	const separator = baseEmbedUrl.includes('?') ? '&' : '?';
	return `${baseEmbedUrl}${separator}${pairs.join('&')}`;
}

export function getExpectedOrigin(embedUrl: string): string {
	return new URL(embedUrl).origin;
}
